/**
 * Язык платформы переводов ВК. Рекомендованно: ru, uk, ua, en, be, kz, pt, es.
 * https://dev.vk.ru/ru/mini-apps/development/launch-params?ref=old_portal#%D0%9F%D0%B0%D1%80%D0%B0%D0%BC%D0%B5%D1%82%D1%80%D1%8B
 */
export type VkLanguage = string;

/**
 * Извлекает язык пользователя из параметров запуска мини-приложения ВК
 * @param launchParams query-string параметров запуска мини-приложения ВК
 */
export function getLaunchParamsVkLanguage(launchParams: string): VkLanguage | undefined {
  const foundLanguagePair = (launchParams.startsWith('?') ? launchParams.slice(1) : launchParams)
    .split('&')
    .map((pair) => pair.split('='))
    .find((pair) => pair[0] === 'vk_language');

  return foundLanguagePair && foundLanguagePair[1];
}
